import { type MyAccountValues } from "../myAccountTypes";
import { AFFILIATE_FORM_KEY } from "~/domains/affiliate/types/form";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

interface MyAccountPostData extends MyAccountValues {
  newsletterOne: boolean;
  isEnableFieldsTraining?: boolean;
  isPlusUser?: boolean;
}

const apiUrl = occUrl("/account/update");

export interface MyAccountValidationDTO {
  oldPasswordWrong: boolean;
  success: boolean;
  lmsState: string;
}

export const editMyAccount = (data: MyAccountPostData): Promise<MyAccountValidationDTO> => {
  const isPreferredSalesPartner = !!data[AFFILIATE_FORM_KEY]?.id;
  const commonData = {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    newPassword: data.newPassword,
    oldPassword: data.oldPassword,
    company: data.company,
    industrySector: data.industrySector,
    jobTitle: data.jobTitle,
    functionalArea: data.functionalArea,
    line1: data.address,
    line2: data.addressAdditional,
    zipCode: data.zipCode,
    city: data.city,
    country: data.country,
    phone: data.phone,
    salutationCode: data.salutation,
    titleCode: data.title,
    newsletterOne: data.newsletterOne,
    privacyPolicy: data.privacyPolicy,
    isPreferredSalesPartner: isPreferredSalesPartner,
    affiliateId: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.id ?? undefined : undefined,
    subsidiary: isPreferredSalesPartner ? data[AFFILIATE_FORM_KEY]?.subsidiary ?? undefined : undefined,
    lmsRequest: data.isEnableFieldsTraining,
  };
  const bodyData = !data.isEnableFieldsTraining
    ? !data.isPlusUser
      ? {
          email: data.email,
          firstName: data.firstName,
          lastName: data.lastName,
          newPassword: data.newPassword,
          oldPassword: data.oldPassword,
          salutationCode: data.salutation,
          titleCode: data.title,
          jobTitle: data.jobTitle,
          functionalArea: data.functionalArea,
          lmsRequest: data.isEnableFieldsTraining,
          newsletterOne: data.newsletterOne,
        }
      : {
          ...commonData,
        }
    : {
        ...commonData,
        customerCategoryCode: data.customerCategory,
        knowledgeAreaCode: data.knowledgeArea,
        languageIsoCode: data.language,
        vatNumber: data.vat,
      };
  return occFetch(apiUrl, {
    body: JSON.stringify(bodyData),
    method: "PUT",
    headers: {
      "content-type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json() as Promise<MyAccountValidationDTO>;
    }
  });
};
